import axios from '@/plugins/axios';

const metricsUrl = '/api/explore/track-event';

export function useAnalytics() {
    const pageview = (url) => {
        axios.post(metricsUrl, {
            event_name: 'page_view',
            value: window.location.host,
            props: {
                url: url,
            },
        })
    }

    const purchase = (url, amount) => {
        axios.post(metricsUrl, {
            event_name: 'purchase',
            value: window.location.host,
            props: {
                url: url,
                amount: amount,
            },
        })
    }

    const trackCustomEvent = (url, name, props) => {
        axios.post(metricsUrl, {
            event_name: name,
            value: window.location.host,
            props: props,
        })
    }
    return {
        pageview,
        purchase,
        trackCustomEvent
     }
}